<template>
  <div>
    <div class="slide-one"></div>
    <div class="content-center" style="padding: 40px 0 80px">
      <div class="warp">
        <div class="title">
          <div class="active">关于我们</div>
          <div @click="turnTo('/addWe')">加入我们</div>
          <div @click="turnTo('/contactWe')">联系我们</div>
        </div>
        <div class="content">
          <div class="content-title">我们是谁</div>
          <div class="content-tips">WHO ARE WE</div>
          <div class="content-p">
            货拉拉是一家拉货搬家跑腿发长途平台，创立于2013年，成长于粤港澳大湾区，是从事同城/跨城货运、企业版物流服务、搬家、零担、跑腿、冷运、汽车租售及车后市场服务的互联网物流商城。通过共享模式整合社会运力资源，完成海量运力储备，并依托移动互联、大数据和人工智能技术，搭建“方便、科技、可靠”的货运信息服务平台，实现多种车型的即时智能调度，为个人、商户及企业提供高效的物流解决方案。
          </div>
          <div class="content-p">
            截至2025年4月，货拉拉业务范围覆盖全球14个市场，包括中国内地、中国香港、东南亚、南亚、中东及南美洲地区，其中中国内地总共覆盖363座城市，月活司机达120万，月活用户达1400万。
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    turnTo(path){
      this.$router.push({ path})
    }
  }
}
</script>

<style lang="scss" scoped>
.slide-one {
  height: 520px;
  background: url(../assets/aboutMe.png) no-repeat center;
  background-size: cover;
  position: relative;
}
.content-center {
  width: 1080px;
  margin: 0 auto;
  padding: 10px 50px;
}
.warp {
  display: flex;
  .title {
    width: 100px;
    height: 344px;
    padding-top: 20px;
    border-right: 1px solid #eaeaea;
    font-size: 14px;
    font-weight: 400;
    color: #2f3439;
    line-height: 33px;
    > div {
      padding: 0 13px;
      cursor: pointer;
    }
    .active {
      color: #f16622;
      position: relative;
    }
    .active::before {
      content: "";
      position: absolute;
      top: 10px;
      left: 0;
      width: 2px;
      height: 13px;
      background: #f16622;
    }
  }
  .content {
    flex: 1;
    padding: 0 40px;
    .content-title {
      font-size: 24px;
      font-weight: 600;
      color: #2f3439;
      line-height: 46px;
      text-align: center;
    }
    .content-tips {
      font-size: 14px;
      color: #768191;
      line-height: 14px;
      text-align: center;
      margin-bottom: 20px;
    }
    .content-p {
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #768191;
      line-height: 18px;
      text-indent: 2em;
      margin-bottom: 18px;
    }
  }
}
</style>